import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-overduedetailsone',
  templateUrl: './usr-overduedetailsone.component.html',
  styleUrls: ['./usr-overduedetailsone.component.css']
})
export class UsrOverduedetailsoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
